
import api from "../utils/api";

const crmService = {
  // User (Staff) API calls
  async getUsers(params = {}) {
    const response = await api.get("/users", params);
    return response.data;
  },
  // Campaign API calls
  async getCampaigns(params = {}) {
    const response = await api.get("/campaigns", params);
    return response.data;
  },

  async getCampaignById(id) {
    const response = await api.get(`/campaigns/${id}`);
    return response.data;
  },

  async createCampaign(campaignData) {
    const response = await api.post("/campaigns", campaignData);
    return response.data;
  },

  async updateCampaign(id, data) {
    const response = await api.put(`/campaigns/${id}`, data);
    return response.data;
  },

  async deleteCampaign(id) {
    const response = await api.delete(`/campaigns/${id}`);
    return response.data;
  },

  // Kanban Status API calls
  async getKanbanStatuses(params = {}) {
    const response = await api.get("/kanban-statuses", params);
    return response.data;
  },

  async getKanbanStatusById(id) {
    const response = await api.get(`/kanban-statuses/${id}`);
    return response.data;
  },

  async createKanbanStatus(statusData) {
    const response = await api.post("/kanban-statuses", statusData);
    return response.data;
  },

  async updateKanbanStatus(id, data) {
    const response = await api.put(`/kanban-statuses/${id}`, data);
    return response.data;
  },

  async deleteKanbanStatus(id) {
    const response = await api.delete(`/kanban-statuses/${id}`);
    return response.data;
  },

  async reorderKanbanStatuses(campaignId, statusIds) {
    const response = await api.put("/kanban-statuses/reorder", {
      campaignId,
      statusIds,
    });
    return response.data;
  },

  // Lead API calls
  async getLeads(params = {}) {
    const response = await api.get("/leads", params);
    return response.data;
  },

  async getLeadById(id) {
    const response = await api.get(`/leads/${id}`);
    return response.data;
  },

  async createLead(leadData) {
    const response = await api.post("/leads", leadData);
    return response.data;
  },

  async updateLead(id, data) {
    const response = await api.put(`/leads/${id}`, data);
    return response.data;
  },

  async deleteLead(id) {
    const response = await api.delete(`/leads/${id}`);
    return response.data;
  },

  async assignLead(id, assignedTo) {
    const response = await api.put(`/leads/${id}/assign`, { assignedTo });
    return response.data;
  },

  async unassignLead(id) {
    const response = await api.put(`/leads/${id}/unassign`);
    return response.data;
  },

  async moveLead(id, statusId) {
    const response = await api.put(`/leads/${id}/move`, { statusId });
    return response.data;
  },

  // Lead Upload API calls
  async uploadLeadsFromCSV(formData) {
    const API_BASE_URL = process.env.REACT_APP_BASE_URL + "/api";
    const token = localStorage.getItem("token");

    const response = await fetch(`${API_BASE_URL}/leads/upload`, {
      method: "POST",
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  async bulkUploadLeads(leads) {
    const response = await api.post("/leads/bulk-upload", { leads });
    return response.data;
  },

  // Kanban Board API calls
  async getKanbanBoard(campaignId, params = {}) {
    const response = await api.get(`/kanban/board/${campaignId}`, params);
    return response.data;
  },

  async getAllKanbanBoards(params = {}) {
    const response = await api.get("/kanban/board", params);
    return response.data;
  },

  async getKanbanStats(params = {}) {
    const response = await api.get("/kanban/stats", params);
    return response.data;
  },
};

export default crmService;
